/* global jQuery, Drupal */
(function ($, Drupal) {
  "use strict";

  Drupal.AjaxCommands.prototype.afterBulkUploadCommand = function () {
    $("#accountsUserList").collapse("show");
    $("#accountsStudentForm").collapse("hide");
    $("#accountsUploadForm").collapse("hide");
    $("#accounts-update-users-form").collapse("hide");
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $(".view-school-members").trigger("RefreshView");
  };

  Drupal.AjaxCommands.prototype.scrollToTopCommand = function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  };

  Drupal.AjaxCommands.prototype.afterSubscriptionCancelCommand = function () {
    $(".view-user-licenses").trigger("RefreshView");
  };

  Drupal.AjaxCommands.prototype.afterNewClassCommand = function () {
    $("#schoolClassList").collapse("show");
    $("#schoolClassForm").collapse("hide");
    $("html, body").animate({ scrollTop: 0 }, "slow");
    $(".view-school-classes").trigger("RefreshView");
  };
})(jQuery, Drupal);
